import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import {
  CallApiGetRateLimits,
  CallApiResetRateLimit,
} from "../Api/Enforcement";
import { initialPaging } from "../Constants/paging";
import { RATE_LIMIT_FUNCTIONS } from "../Constants/rateLimit";
import { formatDate } from "../Utils";
import { SwalError, SwalSuccess } from "../Share/Swal";

export const useAdminRateLimit = () => {
  const [rateLimits, setRateLimits] = useState([]);
  const [paging, setPaging] = useState(initialPaging);
  const pagingRef = useRef(paging);
  const [search, setSearch] = useState("");
  // const [loading, setLoading] = useState(false);

  const [type, setType] = useState(RATE_LIMIT_FUNCTIONS[0]);

  useEffect(() => {
    pagingRef.current = paging;
  }, [paging]);

  const getRateLimits = useCallback(
    (pageNumber) => {
      const data = {
        searchText: search,
        functionName: type.value,
        page:
          pageNumber !== undefined ? pageNumber : pagingRef.current.pageIndex,
        pageSize: 30,
      };

      CallApiGetRateLimits(data, (res) => {
        if (res.Status === "success") {
          var data = res.Response.data;
          setRateLimits(data.Items);
          setPaging((prev) => ({
            ...prev,
            next: data.Next,
            previous: data.Previous,
            totalPages: data.TotalPagesCount,
            pageIndex: data.PageIndex,
          }));
        }
      });
    },
    [search, type]
  );

  useEffect(() => {
    getRateLimits();
  }, [getRateLimits]);

  const handleSelectType = useCallback((type) => {
    setType(type);
    setPaging((prev) => ({ ...prev, pageIndex: 0 }));
  }, []);

  const handleReOpen = useCallback(
    (row) => {
      const data = {
        userId: row.UserId,
        functionType: row.FunctionType,
      };
      CallApiResetRateLimit(data, (res) => {
        if (res === "success") {
          getRateLimits(0);
          SwalSuccess("Mở khóa thành công !");
        } else {
          SwalError(
            "Đã xảy ra lỗi!\nLiên hệ với admin để biết thêm chi tiết !"
          );
        }
      });
    },
    [getRateLimits]
  );

  const rateLimitColumns = useMemo(
    () => [
      {
        header: "UserId/IP",
        key: "UserId",
      },
      { header: "Chức năng", key: "FunctionType" },
      { header: "Số lần thất bại", key: "FailedAttempts" },
      { header: "Mức độ khóa", key: "LockoutLevel" },
      {
        header: "Bắt đầu khóa",
        key: "LockoutStartTime",
        render: (row) => formatDate(row.LockoutStartTime),
      },
      {
        header: "Kết thúc khóa",
        key: "LockoutEndTime",
        render: (row) => formatDate(row.LockoutEndTime),
      },
      {
        header: "",
        key: "",
        render: (row) => (
          <button
            style={{
              backgroundColor: "#2b9748",
              color: "#fff",
              border: "none",
              padding: "3px 5px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => handleReOpen(row)}
          >
            Mở khóa
          </button>
        ),
      },
    ],
    [handleReOpen]
  );

  return {
    rateLimits,
    paging,
    search,
    setSearch,
    getRateLimits,
    type,
    handleSelectType,
    rateLimitColumns,
  };
};
